import { handleActions } from 'redux-actions';
import { AlarmMap } from 'types';
import {
    AlarmsLoadRequestAction,
    AlarmsLoadSuccessAction,
    AlarmsLoadFailureAction,
    AlarmReceivedAction,
} from 'actions/alarmActions';
import { SetDateAction } from 'actions/monitoringActions';
import { LogoutAction } from 'actions/shellActions';

export type State = Readonly<{
    data: Readonly<AlarmMap>;
    loading: boolean;
    error: Error | null;
}>;

const noAlarms = Object.freeze<AlarmMap>({});

export const initialState = Object.freeze<State>({
    data: noAlarms,
    loading: false,
    error: null,
});

export type ReducerAction =
    AlarmsLoadRequestAction
    | AlarmsLoadSuccessAction
    | AlarmsLoadFailureAction
    | AlarmReceivedAction
    // Monitoring Actions
    | SetDateAction
    // Shell Actions
    | LogoutAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const alarmReducer: Reducer = handleActions({
    ALARMS_LOAD_REQUEST(state: State, action: AlarmsLoadRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    ALARMS_LOAD_SUCCESS(state: State, action: AlarmsLoadSuccessAction) {
        return {
            ...state,
            data: action.payload,
            loading: false,
            error: null,
        };
    },

    ALARMS_LOAD_FAILURE(state: State, action: AlarmsLoadFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

    ALARM_RECEIVED(state: State, action: AlarmReceivedAction) {
        const alarmMap = action.payload;
        return {
            ...state,
            data: {
                ...state.data,
                ...alarmMap,
            },
        };
    },


    //
    //  Monitoring Actions
    //
    SET_DATE(state: State, action: SetDateAction) {
        return {
            ...state,
            data: noAlarms,
        };
    },


    //
    //  Shell Actions
    //
    LOGOUT(state: State, action: LogoutAction) {
        return initialState;
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/alarmReducer.ts